import { IdNamePair } from '../../redux/common/definitions';
import { Role } from '../../redux/user/definitions';
import RoleGroup from '../../types/Roles/roleGroup';
import { apiBaseUrl, apiCall } from '../api'; // or provide the correct relative path

const baseURL = apiBaseUrl;

export const getRolesFromApi = async (): Promise<IdNamePair> => {
  const init = {
    method: 'GET',
    auth: true,
  };

  return await apiCall<IdNamePair>(`${baseURL}/roles`, init);
};

export const getRolesByRouteFromApi = async (entidad: boolean): Promise<Role[]> => {
  const init = {
    method: 'GET',
  };

  const route = entidad ? 'create_entity' : 'create_user';

  const { data } = await apiCall<{ data: Role[] }>(`${baseURL}/roles/route/${route}`, init);
  return data;
};

export const getRolesByGroupFromApi = async (roleGroup: RoleGroup): Promise<Role[]> => {
  const init = {
    method: 'GET',
  };

  const { data } = await apiCall<{ data: Role[] }>(`${baseURL}/roles/group/${roleGroup.value()}`, init);
  return data;
};
